var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4167 1.41675H13.25C9.34 1.41675 6.16667 4.59008 6.16667 8.50008V19.8334C6.16667 23.7434 9.34 26.9167 13.25 26.9167H27.4167C31.3267 26.9167 34.5 23.7434 34.5 19.8334V8.50008C34.5 4.59008 31.3267 1.41675 27.4167 1.41675ZM13.25 4.25008H27.4167C28.6775 4.25008 29.8108 4.80258 30.59 5.66675L23.3367 12.9201C21.6792 14.5776 18.9875 14.5776 17.33 12.9201L10.0767 5.66675C10.8558 4.78841 11.9892 4.25008 13.25 4.25008ZM27.4167 24.0834H13.25C10.9125 24.0834 9 22.1709 9 19.8334V8.59925L15.3183 14.9176C16.6925 16.2917 18.52 16.9859 20.3333 16.9859C22.1467 16.9859 23.96 16.2917 25.3483 14.9176L31.6667 8.59925V19.8334C31.6667 22.1709 29.7542 24.0834 27.4167 24.0834ZM27.4167 31.1667C27.4167 31.9459 26.7792 32.5834 26 32.5834H7.58333C3.67333 32.5834 0.5 29.4101 0.5 25.5001V9.91675C0.5 9.13758 1.1375 8.50008 1.91667 8.50008C2.69583 8.50008 3.33333 9.13758 3.33333 9.91675V25.5001C3.33333 27.8376 5.24583 29.7501 7.58333 29.7501H26C26.7792 29.7501 27.4167 30.3876 27.4167 31.1667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope-icon.46617bce7c922bfb30c01b0ce1db9212.svg";
export { ForwardRef as ReactComponent };